import { styled } from '@mui/system';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(
  ({ theme, simOnly, standaloneHandset }) => ({
    '& .MuiToggleButtonGroup-grouped': {
      // borderRadius: '100px',
      // backgroundColor: theme.palette.secondary.contrastText,
      '&:hover': {
        // backgroundColor: theme.palette.secondary.contrastText,
      },

      '&.Mui-disabled': {
        border: 0,
      },
      '&.Mui-selected': {
        backgroundColor: !simOnly
          ? theme.palette.primary.textColor3
          : theme.palette.primary.textColor3,
        '&:hover': {
          backgroundColor: !simOnly
            ? theme.palette.primary.textColor3
            : theme.palette.primary.textColor3,
        },
        '& .MuiTypography-root': {
          color: theme.palette.secondary.mobileToggleColor,
        },
      },

      '&:not(:first-of-type)': {
        height: standaloneHandset ? '25px' : '44px',
        [theme.breakpoints.up('sm')]: {
          minWidth: !standaloneHandset && '192px',
        },
        // color: theme.palette.secondary.contrastText,
        border: 0,
        // borderRadius: '100px',
      },
      '&:first-of-type': {
        height: standaloneHandset ? '25px' : '44px',
        border: 0,
        [theme.breakpoints.up('sm')]: {
          minWidth: !standaloneHandset && '192px',
        },
        // borderRadius: '100px',
      },
    },
  })
);
export default StyledToggleButtonGroup;
